export const Style = ({ colors = [] }) => (
  <g id="Estilo2_3_">
    <linearGradient
      id="Multiply_61_"
      gradientUnits="userSpaceOnUse"
      x1="74.69"
      y1="382.1526"
      x2="74.69"
      y2="405.0462"
      gradientTransform="matrix(1 0 0 -1 0 480)"
    >
      <stop offset="5.586999e-03" style={{ stopColor: '#CE77F1' }} />
      <stop offset="0.1593" style={{ stopColor: '#D280EF' }} />
      <stop offset="0.4059" style={{ stopColor: '#DC97EA' }} />
      <stop offset="0.7127" style={{ stopColor: '#EDBDE1' }} />
      <stop offset="1" style={{ stopColor: '#FFE7D8' }} />
    </linearGradient>
    <path
      id="Multiply_8_"
      style={{
        display: 'inline',
        opacity: '0.6',
        fill: 'url(#Multiply_61_)',
        enableBackground: 'new'
      }}
      d="M71.3,79.7 c0,0,3.3,1.6,6.7,0.7c0,0-1.2,2.3-4,1.7C73.1,81.9,71.9,81.3,71.3,79.7z"
    />
    <path
      style={{ display: 'inline', fill: colors[0] }}
      d="M75.5,79.2c-4.9,0-6.7-3-6.8-3.2c-0.1-0.2-0.1-0.5,0.2-0.7c0.2-0.1,0.5-0.1,0.7,0.2 c0.1,0.2,3,4.8,11.9,1.4c0.3-0.1,0.5,0,0.6,0.3s0,0.5-0.3,0.6C79.3,78.9,77.2,79.2,75.5,79.2z"
    />
  </g>
)
